<template>
  <div id="yqlj">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'yqlj'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/setup/yqlj/Yqlj.vue